import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { BaseService } from "./base.service";
import { Exams } from "src/app/models/exams.model";

@Injectable({
    providedIn: 'root'
  })
  export class ExamsService extends BaseService {

    constructor (
      protected apiService: ApiService,
      protected http: HttpClient
    ) {
      super(apiService, http, 'employees');
    }

  getExamsByEmployee(employeeId: number | null) {
    return this.http.get<Exams[]>(`${this.apiUrl}/${employeeId}/exams`);
  }

}
